<!--
 * @Author: your name
 * @Date: 2021-03-23 16:24:09
 * @LastEditTime: 2021-03-23 16:26:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\components\Product.vue
-->
<template>
  <div id='app'>
    <el-dialog :title="titleName" :visible.sync="startNavSync" width="20%" top="40vh">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/img/等待.png" alt="">
        <span style="margin-left:20px;line-height:30px;">该功能正在开发中...</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleName: '',
      startNavSync: false,
    }
  },
  created() { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>